/* tslint:disable */
/* eslint-disable */

/**
 * Supported tender type as for example Cash, CreditCard, DebitCard, GiftCard, GooglePay, ApplePay Other
 */
export enum TenderType {
  ApplePay = 'ApplePay',
  Cash = 'Cash',
  CreditCard = 'CreditCard',
  DebitCard = 'DebitCard',
  GiftCard = 'GiftCard',
  GooglePay = 'GooglePay',
  Other = 'Other',
  None = 'None',
}
